import { app } from '../../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.directory-integration.manage.main.remove', {
        url: '/remove',
        views: {
            '@company.directory-integration.manage': 'companyDirectoryIntegrationManageMainRemove'
        },
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/main/remove/remove-directory.state.js